"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePictureVariant = void 0;
var ProfilePictureVariant;
(function (ProfilePictureVariant) {
    ProfilePictureVariant["Picture"] = "picture";
    ProfilePictureVariant["Initials"] = "initials";
    ProfilePictureVariant["Impersonation"] = "impersonation";
    ProfilePictureVariant["InitialsImage"] = "initialsImage";
})(ProfilePictureVariant || (exports.ProfilePictureVariant = ProfilePictureVariant = {}));
